import { DataColumn } from "../../models/ColumnDefintion";

export class AddColumnDefinition {
  static readonly type = "[ColDef] Add";
  constructor(public payload: DataColumn[]) {}
}

export class RemoveColumnDefinition {
  static readonly type = "[ColDef] Remove";
  constructor() {}
}
